<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/cleaning-supplies/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New cleaning supply
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'cleaning-supply'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/cleaning-supplies`"
    />
  </v-container>
</template>

<script>
export default {
  name: "CleaningSupplyList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Price', value: 'price' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['name', 'price'],
    search_param: '',
    attribute_list: ['id', 'name', 'price'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
